module.exports = __webpack_public_path__ + "static/media/Close.c1746405.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Close.svg
// module id = 130
// module chunks = 0